import { Component, Prop } from '@atomify/core';
import { Fragment, h } from '@atomify/jsx';
import { userStore, wishlistLength } from '@store/user';
import { useTranslate } from '@utilities/hooks';

@Component({
    tag: 'bpd-wishlist-header',
})
export class WishlistHeader extends HTMLElement {
    @Prop({ reRender: true }) wishlistLength: number;

    componentDidLoad() {
        this.subscribe();
    }

    subscribe() {
        userStore.subscribe(() => {
            this.wishlistLength = wishlistLength();
        }, ['wishlist']);
    }

    render() {
        const theseTranslation = useTranslate('Wishlist-These');
        const housesAreSavedTranslation = useTranslate('Wishlist-HousesAreSaved');
        const wishlistIsEmptyTranslation = useTranslate('Wishlist-WishlistIsEmpty');
        const myWishlistTranslation = useTranslate('Wishlist-MyWishlist');

        return (
            <div class="c-wishlist-header">
                <h1 class="u-h3 u-h1--md">{myWishlistTranslation}</h1>
                <span class="wishlist-header__wishlist-text u-body-normal u-subtitle-1--md">
                    {this.wishlistLength ? (
                        <Fragment>
                            {theseTranslation} {this.wishlistLength} {housesAreSavedTranslation}
                        </Fragment>
                    ) : (
                        <Fragment>{wishlistIsEmptyTranslation}</Fragment>
                    )}
                </span>
            </div>
        );
    }
}
